var exports = {
  "k": "xe533113f--cabce0--container",
};

module.exports = exports;
